import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

const { Types, Creators } = createActions({
  getTruckersRequest: null,
  getTruckersSuccess: ['truckers'],
  getTruckersFailure: ['error'],
  getOneTruckerRequest: ['id'],
  getOneTruckerSuccess: ['oneTrucker'],
  getOneTruckerFailure: ['error'],
  getCpfTruckerRequest: ['cpf'],
  getCpfTruckerSuccess: ['oneTrucker'],
  getCpfTruckerFailure: ['error'],
  addTruckerRequest: ['trucker', 'closeModal'],
  addTruckerSuccess: ['trucker'],
  addTruckerFailure: ['error'],
  updateTruckerRequest: ['id', 'trucker', 'closeModal'],
  updateTruckerSuccess: ['trucker'],
  updateTruckerFailure: ['error'],
  removeTruckerRequest: ['id'],
  removeTruckerSuccess: ['id'],
  removeTruckerFailure: ['error'],
  openModalTrucker: ['trucker'],
  closeModalTrucker: null,
  reportPendingRequest: ['id', 'body', 'closeModal'],
  reportPendingSuccess: null,
  reportPendingFailure: ['error'],
  updateAditionalDocumentRequest: [
    'values',
    'url_document',
    'id',
    'modalClose',
  ],
  updateAditionalDocumentSuccess: null,
  updateAditionalDocumentFailure: ['error'],
  setDocumentDataRequest: ['values', 'closeModal'],
  setDocumentDataSuccess: null,
  setDocumentDataFailure: ['error'],
  setSelectedTrucker: ['selectedTrucker'],
  setActualMarkerTrucker: ['truckerLocation'],
  openTruckerDrawer: null,
  closeTruckerDrawer: null,
});

export const TruckerTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  truckers: [],
  oneTrucker: {},
  selectedTrucker: {},
  truckerDrawer: false,
  actualMarkerTrucker: null,
  isLoading: false,
  error: null,
  modalTruckerOpen: false,
  truckerSelected: null,
});

/* Reducers */

const getTruckersRequest = (state) =>
  state.merge({
    isLoading: true,
  });

// Função para formatar data para input type="date" (YYYY-MM-DD)
const formatDateForInput = (dateValue) => {
  if (!dateValue) return '';
  try {
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error('Erro ao formatar data:', error);
    return '';
  }
};

// Função para normalizar trucker (formatar datas)
const normalizeTrucker = (trucker) => {
  if (!trucker) return trucker;
  return {
    ...trucker,
    cnh_expiration: trucker.cnh_expiration ? formatDateForInput(trucker.cnh_expiration) : '',
  };
};

const getTruckersSuccess = (state, { truckers }) =>
  state.merge({
    truckers: Array.isArray(truckers) ? truckers.map(normalizeTrucker) : [],
    isLoading: false,
  });

const getTruckersFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const getOneTruckerRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const getOneTruckerSuccess = (state, { oneTrucker }) =>
  state.merge({
    oneTrucker: normalizeTrucker(oneTrucker),
    isLoading: false,
  });

const getOneTruckerFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const getCpfTruckerRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const getCpfTruckerSuccess = (state, { oneTrucker }) =>
  state.merge({
    oneTrucker: normalizeTrucker(oneTrucker),
    isLoading: false,
  });

const getCpfTruckerFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const reportPendingRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const reportPendingSuccess = (state) =>
  state.merge({
    isLoading: false,
  });

const reportPendingFailure = (state) =>
  state.merge({
    isLoading: false,
  });

const updateAditionalDocumentRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const updateAditionalDocumentSuccess = (state) =>
  state.merge({
    isLoading: false,
  });

const updateAditionalDocumentFailure = (state) =>
  state.merge({
    isLoading: false,
  });

const setDocumentDataRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const setDocumentDataSuccess = (state) =>
  state.merge({
    isLoading: false,
  });

const setDocumentDataFailure = (state) =>
  state.merge({
    isLoading: false,
  });

const setSelectedTrucker = (state, { selectedTrucker }) =>
  state.merge({
    selectedTrucker,
  });

const setActualMarkerTrucker = (state, { truckerLocation }) =>
  state.merge({
    setActualMarkerTrucker: truckerLocation,
  });

const openTruckerDrawer = (state, { selectedTrucker }) =>
  state.merge({
    truckerDrawer: true,
  });

const closeTruckerDrawer = (state) =>
  state.merge({
    truckerDrawer: false,
  });

const addTruckerRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const addTruckerSuccess = (state, { trucker }) =>
  state.merge({
    truckers: [...state.truckers, normalizeTrucker(trucker)],
    isLoading: false,
  });

const addTruckerFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const updateTruckerRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const updateTruckerSuccess = (state, { trucker }) =>
  state.merge({
    truckers: state.truckers.map((t) => (t.id === trucker.id ? normalizeTrucker(trucker) : t)),
    isLoading: false,
  });

const updateTruckerFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const removeTruckerRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const removeTruckerSuccess = (state, { id }) =>
  state.merge({
    truckers: state.truckers.filter((t) => t.id !== id),
    isLoading: false,
  });

const removeTruckerFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const openModalTrucker = (state, { trucker }) =>
  state.merge({
    modalTruckerOpen: true,
    truckerSelected: trucker ? normalizeTrucker(trucker) : null,
  });

const closeModalTrucker = (state) =>
  state.merge({
    modalTruckerOpen: false,
    truckerSelected: null,
  });

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_TRUCKERS_REQUEST]: getTruckersRequest,
  [Types.GET_TRUCKERS_SUCCESS]: getTruckersSuccess,
  [Types.GET_TRUCKERS_FAILURE]: getTruckersFailure,
  [Types.GET_ONE_TRUCKER_REQUEST]: getOneTruckerRequest,
  [Types.GET_ONE_TRUCKER_SUCCESS]: getOneTruckerSuccess,
  [Types.GET_ONE_TRUCKER_FAILURE]: getOneTruckerFailure,
  [Types.GET_CPF_TRUCKER_REQUEST]: getCpfTruckerRequest,
  [Types.GET_CPF_TRUCKER_SUCCESS]: getCpfTruckerSuccess,
  [Types.GET_CPF_TRUCKER_FAILURE]: getCpfTruckerFailure,
  [Types.ADD_TRUCKER_REQUEST]: addTruckerRequest,
  [Types.ADD_TRUCKER_SUCCESS]: addTruckerSuccess,
  [Types.ADD_TRUCKER_FAILURE]: addTruckerFailure,
  [Types.UPDATE_TRUCKER_REQUEST]: updateTruckerRequest,
  [Types.UPDATE_TRUCKER_SUCCESS]: updateTruckerSuccess,
  [Types.UPDATE_TRUCKER_FAILURE]: updateTruckerFailure,
  [Types.REMOVE_TRUCKER_REQUEST]: removeTruckerRequest,
  [Types.REMOVE_TRUCKER_SUCCESS]: removeTruckerSuccess,
  [Types.REMOVE_TRUCKER_FAILURE]: removeTruckerFailure,
  [Types.OPEN_MODAL_TRUCKER]: openModalTrucker,
  [Types.CLOSE_MODAL_TRUCKER]: closeModalTrucker,
  [Types.REPORT_PENDING_REQUEST]: reportPendingRequest,
  [Types.REPORT_PENDING_SUCCESS]: reportPendingSuccess,
  [Types.REPORT_PENDING_FAILURE]: reportPendingFailure,
  [Types.UPDATE_ADITIONAL_DOCUMENT_REQUEST]: updateAditionalDocumentRequest,
  [Types.UPDATE_ADITIONAL_DOCUMENT_SUCCESS]: updateAditionalDocumentSuccess,
  [Types.UPDATE_ADITIONAL_DOCUMENT_FAILURE]: updateAditionalDocumentFailure,
  [Types.SET_DOCUMENT_DATA_REQUEST]: setDocumentDataRequest,
  [Types.SET_DOCUMENT_DATA_SUCCESS]: setDocumentDataSuccess,
  [Types.SET_DOCUMENT_DATA_FAILURE]: setDocumentDataFailure,
  [Types.SET_SELECTED_TRUCKER]: setSelectedTrucker,
  [Types.OPEN_TRUCKER_DRAWER]: openTruckerDrawer,
  [Types.CLOSE_TRUCKER_DRAWER]: closeTruckerDrawer,
  [Types.SET_ACTUAL_MARKER_TRUCKER]: setActualMarkerTrucker,
});
